import * as actionTypes from '../actionTypes';

export const setUser = user => ({ type: actionTypes.SET_USER, user });
export const setUsers = users => ({ type: actionTypes.SET_USERS, users });
